
export const MOBILE_NAVIGATION = 'MOBILE_NAVIGATION';
export const mobileNavigation = (status) => {
  return {
    type: MOBILE_NAVIGATION,
    status
  }
}
